//
// Copyright (c) 2022-2023 Winlin
//
// SPDX-License-Identifier: AGPL-3.0-or-later
//
import React from 'react';

// The context for env of API /terraform/v1/mgmt/envs
export const SrsEnvContext = React.createContext();

